import type { LocalBellRow } from "./bellRows";

// #178: the first profile write failed at the invitation gate, so the athlete
// is in with no name. One row of the bell, until the name is there: the tap
// opens Account, where the name field is. One builder for the phone and the
// web; each host keeps its own mark (createOwnerMark) and its own wiring.

/** `at` is the mark's date: the row's date and its version. */
export function profileNameRowOf(at: string): LocalBellRow {
  return {
    origin: "local",
    id: "profileName",
    version: at,
    kind: "profileName",
    createdAt: at,
    titleKey: "inbox.local.profileName.title",
    bodyKey: "inbox.local.profileName.body",
    // The bell only (decision 30/10): no system notification.
    urgent: false,
    target: { to: "settingsAccount" },
    // Stays until the name is saved; no hide.
    actions: ["open"],
  };
}
